import { type ViewportToolsetDefinition } from "@/viewport-tools/core";
import { VIEWPORT_TOOLSET_PLUGINS } from "@/viewport-tools/plugins";

export const VIEWPORT_TOOLSET_DEFINITIONS: ViewportToolsetDefinition[] =
  VIEWPORT_TOOLSET_PLUGINS.map((plugin) => plugin.toolset);
